import api from './api';

const getMyPurchases = async () => {
    const response = await api.get('/my-purchases');
    return response.data.purchases || [];
};

// The download route is protect-gated, so a plain <a href>/<iframe src> can't
// carry the auth header — fetch it as a blob (api.js's interceptor attaches
// Authorization). Backend streams the PDF bytes directly (no redirect to the
// real Cloudinary URL, see book.js) with Content-Disposition: inline. This
// blob feeds the in-app react-pdf viewer (PDFViewer.jsx) — it is no longer
// force-downloaded/saved (that behaviour was removed in Phase 6 View-only
// PDF-iii; the old downloadBook() this replaced did `link.download = ...`).
const getPdfBlob = async (bookId) => {
    const response = await api.get(`/books/${bookId}/download`, { responseType: 'blob' });
    return response.data;
};

// Unified purchase history (book + boardCategory + mockTest) — parallel to
// getMyPurchases() above (book-only), which MyBookPurchases.jsx still uses.
const getAllPurchases = async () => {
    const response = await api.get('/my-purchases/all');
    return response.data.purchases || [];
};

const bookPurchaseService = {
    getMyPurchases,
    getPdfBlob,
    getAllPurchases
};

export default bookPurchaseService;
